import { render } from "./KatmanlarSvg.vue?vue&type=template&id=3919081e&scoped=true"
import script from "./KatmanlarSvg.vue?vue&type=script&lang=js"
export * from "./KatmanlarSvg.vue?vue&type=script&lang=js"

import "./KatmanlarSvg.vue?vue&type=style&index=0&id=3919081e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3919081e"]])

export default __exports__